<template>
  <div class="document">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "DocumentsFrame"
};
</script>

<style scoped lang="scss">
.document {
  max-width: 35rem;
  margin: 0 auto;
}
</style>
